import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Helper_Class } from '../../helper_class';
import { ipaddress } from '../../ipaddress';
import { MenuViewService } from '../../../app/common-module/menu-view/menu-view.service';

@Component({
  selector: 'app-outsource-centre-list',
  templateUrl: './outsource-centre-list.component.html',
  styleUrls: ['./outsource-centre-list.component.scss']
})
export class OutsourceCentreListComponent implements OnInit {
  public outsourceList:any=[];
  dtOptions: DataTables.Settings = {};

  constructor(public messageservice:MenuViewService ,public toastr: ToastrService,public http: HttpClient) { 

  }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'simple_numbers_no_ellipses',
      pageLength: 25,
      "lengthMenu": [ [25, 50, -1], [25, 50, "All"] ],
      "order": [[0, 'asc']],
      "columnDefs": [
        { "orderable": false, "targets": [] },
      ],
      "language": {
        "search": "<img src='../../../assets/img/search.png' width='18px'/>",
        searchPlaceholder: "Search by name,location,contact no"
      },
      dom: '<"row"<"col-sm-6 col-xs-12"f><"col-sm-6 col-xs-12 d-flex justify-content-end"l>><"table-responsive"t><"row mt-1 d-flex"<"col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3 pad_top_10"><"col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 text-center sm-order-last"i><"col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center"p>>'
    };

    this.getOutsourceList();
  }

  getOutsourceList(){
    var diagid= Helper_Class.getInfo().hospitals[0].hptl_clinic_id;
    var headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    this.http.post(ipaddress.getIp + "diagnosiscontroller/gosl", { diag_center_id: diagid }, 
    { headers: headers }).subscribe(
      data => {
        var dataval = JSON.parse(JSON.stringify(data))
        if(dataval != undefined && dataval.outsource_list != undefined) {
          this.outsourceList = dataval.outsource_list;
        }
      })
  }

  createOutCentre(){
    this.messageservice.sendMessage("out-centre");
  }

  getTests(list){
    Helper_Class.setOutsource(list)
    this.messageservice.sendMessage("out-test-map");
  }
}
